import serviceBase from '../../../Services/serviceBase'

class NewsDialogActions {
  getNewsDetail = async (id) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements/news-detail-by-id/${id}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getNewsPreviewDetail = async (id) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-preview/details/${id}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getNewsEmitStart = async (fireDepartment, id) => {
    let url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements`
    serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}?id=${id}`)
  }

  async publish(id, sendPushNotification, iarMember) {
    try {
      let url = `${window._env_.COMMUNITY_API_URL}/news-preview/${id}/publish`

      if (sendPushNotification) url += '?sendPushNotification=' + sendPushNotification

      const response = await serviceBase.post(url, undefined, { fullusername: iarMember.fullName })

      if (response?.status !== 200) throw new Error(response.data)

      return response.data
    } catch (err) {
      console.error(err)
      throw new Error('Error attempting to publish News')
    }
  }
}

const newsDialogActions = new NewsDialogActions()

export default newsDialogActions
